import React, { useState } from "react";
import axios from "axios";
import {
  Button,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import DisplayZBericht from "./CashRegisterDemoZBericht";
import { useCookies } from "react-cookie";

const KASSE_ENDPOINT = "https://fkcrenezvf.execute-api.eu-central-1.amazonaws.com/Prod";
const POLL_INTERVAL_MS = 3000;

function CashpointClosingButton({ clientId }) {
  const [zBerichtData, setZBerichtData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [zBerichtDialogOpen, setZBerichtDialogOpen] = useState(false);
  const [confirmationText, setConfirmationText] = useState("");
  
  const [cookies] = useCookies(["crKey"]);
    

  const fetchClosingUntilReady = async (closing_id) => {
    try {
      const res = await axios.get(
        `${KASSE_ENDPOINT}/cash_point_closing`,
        {
          params: { closing_id },
          headers: {Authorization: `Bearer ${cookies.crKey} y 1 z`, }
        }
      );
      if (res.data?.state === "PENDING") {
        setTimeout(() => fetchClosingUntilReady(closing_id), POLL_INTERVAL_MS);
      } else {
        setZBerichtData(res.data.cash_point_closing);
        setLoading(false);
      }
    } catch (err) {
      console.error("Fehler beim Abrufen des Z-Berichts", err);
      setLoading(false);
      alert("Fehler beim Abrufen des Z-Berichts");
      setZBerichtDialogOpen(false);
    }
  };

  const handleClosing = async () => {
    const closing_id = uuidv4();
    setLoading(true);
    setZBerichtDialogOpen(true);

    try {
      const postRes = await axios.post(
        `${KASSE_ENDPOINT}/cash_point_closing`,
        { client_id: clientId, closing_id },
        {
          headers: {
            Authorization: `Bearer ${cookies.crKey} y 1 z`,
            "Content-Type": "application/json"
          }
        }
      );

      const id = postRes.data?.closing_id;
      if (!id) throw new Error("Keine closing_id im Response");

      fetchClosingUntilReady(id);
    } catch (err) {
      console.error(err);
      if(err.response.status === 409){
        alert("Es gibt keine Transaktionen.");
      }else{
        alert("Fehler beim Erstellen des Z-Berichts. Technik informieren.");
      }
      setLoading(false);
      setZBerichtDialogOpen(false);
    }
  };

  const handleConfirm = () => {
    if (confirmationText.trim().toLowerCase() !== "ja") {
      alert('Bitte geben Sie "Ja" ein, um fortzufahren.');
      return;
    }

    setConfirmOpen(false);
    setConfirmationText("");
    handleClosing();
  };

  return (
    <Box>
      <Button
        variant="contained"
        color="secondary"
        disabled={loading}
        onClick={() => setConfirmOpen(true)}
      >
        {loading ? <CircularProgress size={20} /> : "Z-Bericht / Tagesabschluss erstellen"}
      </Button>

      {/* Bestätigungsdialog */}
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Bestätigung erforderlich</DialogTitle>
        <DialogContent>
          <Typography gutterBottom>
            Möchten Sie den Tagesabschluss jetzt erstellen?
            <br />
            Bitte geben Sie <strong>Ja</strong> ein, um fortzufahren.
          </Typography>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            label="Antwort"
            value={confirmationText}
            onChange={(e) => setConfirmationText(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Abbrechen</Button>
          <Button onClick={handleConfirm} variant="contained">Bestätigen</Button>
        </DialogActions>
      </Dialog>

      {/* Z-Bericht Dialog */}
      <Dialog
        open={zBerichtDialogOpen}
        onClose={() => {
          if (!loading) {
            setZBerichtDialogOpen(false);
            setZBerichtData(null);
          }
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Z-Bericht</DialogTitle>
        <DialogContent dividers>
          {loading && (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="150px">
              <CircularProgress />
            </Box>
          )}
          {!loading && zBerichtData && (
            <DisplayZBericht data={{cash_point_closing:zBerichtData}} />
          )}
        </DialogContent>
        {!loading && (
          <DialogActions>
            <Button onClick={() => {
              setZBerichtDialogOpen(false);
              setZBerichtData(null);
            }}>
              Schließen
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </Box>
  );
}

export default CashpointClosingButton;
